import type { IStaffAssignItem } from 'AppointmentBox/ModalConfirmGroup';
import { ANYONE_ID } from 'Calendar/anyone';
import { GROUP_NOTE_SEPARATOR } from 'Calendar/appointment-style-a';
import { IBodyApiQuickBooking } from 'services/types/quickBooking';
import type { IQuickServiceItem } from './signal';

/** Phan state cua Quick Booking dung chung cho ca nhom: khach, gio, dich vu, ghi chu. */
export type IQuickBookingGroupState = {
  customerId: number | string;
  duration: number;
  /** Da o dinh dang API: `MM/DD/YYYY HH:mm`. */
  startTime: string;
  note: string;
  callerId: string;
  services: IQuickServiceItem[];
};

/** `label` cua mot dich vu la ten hien thi; kieu khai bao la `any` nen ep ve chuoi o day. */
export const serviceNamesOf = (services: IQuickServiceItem[]): string[] =>
  services.map(o => `${o.label ?? ''}`.trim()).filter(Boolean);

/**
 * Note cua mot lan dat nhom: `Group: 3 Gel, Pedi | ghi chu cua nhan vien`.
 *
 * Tien to `Group:` la thu duy nhat cho biet day la lich nhom — ban ghi lich hen khong co
 * truong nao khac de phan biet — nen luon duoc ghi, ke ca khi nhan vien da go ghi chu rieng.
 * Ghi chu do di sau dau ngan cach de khong bi tien to nuot mat.
 */
export const buildGroupNote = (
  totalPeople: number,
  serviceNames: string[],
  note?: string | null,
): string => {
  const marker = `Group: ${totalPeople} ${serviceNames.join(', ')}`.trim();
  const typed = (note || '').trim();
  return typed ? `${marker}${GROUP_NOTE_SEPARATOR}${typed}` : marker;
};

/**
 * Mot the trong buoc gan tho thanh mot lich rieng: cung khach, cung gio, cung dich vu,
 * khac nguoi lam.
 *
 * `requestStaff` di theo tung the vi khach co the chi dinh dung nguoi cho vai lich trong
 * nhom; `totalPeople` lay theo so the that su duoc gan, khong phai so da bam, vi tiem co
 * the it tho hon so khach.
 */
export const buildQuickBookingGroupItems = (
  state: IQuickBookingGroupState,
  staffAssigns: IStaffAssignItem[],
): IBodyApiQuickBooking[] => {
  const totalPeople = staffAssigns.length;
  const note = buildGroupNote(totalPeople, serviceNamesOf(state.services), state.note);
  return staffAssigns.map(o => ({
    customerId: state.customerId,
    bookingType: 0,
    duration: state.duration,
    // Buoc gan tho luon tra ve nguoi cu the, nhung van tinh theo id de payload khong noi sai
    // neu danh sach the thay doi ve sau.
    isAnybody: o.staff?.id === ANYONE_ID ? 1 : 0,
    note,
    requestStaff: !!o.requestStaff,
    services: state.services.map(s => ({
      id: s.id || 0,
      serviceName: s.label,
      price: 0,
    })),
    staffId: parseInt(o.staff?.id || ''),
    startTime: state.startTime,
    totalPeople,
    callerId: state.callerId || '',
  } as IBodyApiQuickBooking));
};
